/** Shared Farsi lookup maps for drapery checkout details (module-level, stable references). */

export const DRAPERY_SEWING_MODEL_IDS = ["0099", "0321"];

export const FA_LINING = {
  Unlined: "بدون آستر",
  "Standard Lining": "آستردوزی استاندارد",
  "Privacy Lining": "آستردوزی ضخیم",
  Right: "راست",
};

export const FA_PANEL_COVERAGE = {
  Full: "پوششی",
  "Standard Lining": "آستردوزی استاندارد",
  Decorative: "دکوری",
};

export const FA_PANEL_TYPE = {
  "Single Panel": "تک پنل، سمت چپ",
  "Standard Lining": "آستردوزی استاندارد",
  "Pair, Split Draw": "جفت پنل،دو طرف",
  "Single Panel, Right": "تک پنل، سمت راست",
};

export const FA_GROMMET_FINISH = {
  "Satin Brass": "برنجی",
  "Standard Lining": "آستردوزی استاندارد",
  "Satin Nickel": "نقره‌ای",
  "Gun Metal": "دودی صیقلی",
};

export const FA_HARDWARE_OPTION = {
  "I Have 28mm Rod": "من میله پردهِ ۲۸ میل دارم",
  "I Have 25mm Rod": "من میله پردهِ ۲۵ میل دارم",
  "Standard Lining": "آستردوزی استاندارد",
  "I Have Others": "من چیز دیگری دارم",
  "I Have Motorized Track": "من تراک موتوری دارم",
  "I Have Standard Track": "من تراک استاندارد دارم",
  "I Have Track With Cord Draw": "من تراک اتومات دارم",
};

export const FA_HEADER_STYLE = {
  Grommet: "پانجی",
  "Standard Lining": "آستردوزی استاندارد",
  Right: "راست",
  "Inverted Box Pleat": "پلیسه",
  "Pencil Pleat": "ساده",
};

export const FA_METAL_VALANCE_COLOR = {
  Black: "سیاه",
  White: "سفید",
  Silver: "نقره ای",
};

export const FA_CONTROL_POSITION = {
  Right: "راست",
  Left: "چپ",
};

export const FA_ROLL_TYPE = {
  Standard: "استاندارد",
  Premium: "اعلا",
  Exposed: "بدون قاب با درپوش فلزی",
  Upholstered: "قاب با روکش پارچه",
  MetalValance: "قاب با درپوش فلزی",
  MetalValanceFabricInsert: "قاب با درپوش پارچه\u200Cای",
};

export const FA_BRACKET_TYPE = {
  "Round Edge": "لبه‌گرد",
  Left: "چپ",
  "Square Edge": "لبه‌مربع",
};

export const FA_BRACKET_COLOR = {
  "Satin Brass": "برنجی ",
  Left: "چپ",
  "Satin Nickel": "نقره ای ",
  "Old Brass(OB)": "برنجی",
  "Natural Aluminium (NA)": "الومینیوم طبیعی",
  "Black Nickel (BN)": "مشکی ",
  "Old Brass (OB)": "برنجی",
};

export const FA_HEM_STYLE = {
  Straight: "صاف",
  Left: "چپ",
  Wave: "مواج",
  Scallop: "دایره\u200Cای",
  Traditional: "کنگره\u200Cدار",
};

export const FA_BOTTOM_BAR_STYLE = {
  "Sewn-In": "دوخته شده داخل پارچه",
  Left: "چپ",
  "Decorative Metal Bar": "وزنه تزئینی",
};

export const FA_FEATURES = {
  Standard: "استاندارد",
  Premium: "اعلا",
};
